import dayjs from 'dayjs';
import type { TTimeSetting } from '@timeedit/types';
import { TEInput } from '@timeedit/ui-components';
import { TimePicker } from '@timeedit/ui-components/antd';

type Props = {
  value?: TTimeSetting;
  onChange: (value: TTimeSetting) => void;
  label?: string;
  tooltip?: string;
  disabled?: boolean;
};

const TimeRangePicker = ({
  value,
  onChange,
  label,
  tooltip,
  disabled,
}: Props) => {
  const RangPicker = (
    <TimePicker.RangePicker
      size="small"
      onChange={(dates) =>
        onChange({
          startTime: dates?.[0] && getTimeFromDayjs(dates[0]),
          endTime: dates?.[1] && getTimeFromDayjs(dates[1]),
        })
      }
      format={'HH:mm'}
      needConfirm={false}
      value={
        value && [
          getDayjsFromTime(value.startTime),
          getDayjsFromTime(value.endTime),
        ]
      }
      disabled={disabled}
    />
  );
  return label ? (
    <TEInput.LabelWrapper label={label} tooltip={tooltip}>
      {RangPicker}
    </TEInput.LabelWrapper>
  ) : (
    RangPicker
  );
};

export default TimeRangePicker;

const getDayjsFromTime = (time?: number) => {
  if (!time) return undefined;

  return dayjs().startOf('day').add(time, 'seconds');
};

const getTimeFromDayjs = (dayjsTime?: dayjs.Dayjs) => {
  if (!dayjsTime) return undefined;

  return dayjsTime.diff(dayjs().startOf('day'), 'seconds');
};
